'use strict';
var ENVIRONMENT = require('../internals/environment');

module.exports = ENVIRONMENT === 'NODE';



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/environment-is-node.js
// module id = 128
// module chunks = 13